import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, FormArray } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../../environments/environment';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-horario-atendimento',
  templateUrl: './horario-atendimento.component.html',
  styleUrls: ['./horario-atendimento.component.scss']
})
export class HorarioAtendimentoComponent implements OnInit {
  public realDeskForm: FormGroup;
  public isLoading: boolean = false;
  public dias: string[] = ['Dom', 'Seg', 'Ter', 'Qua', 'Qui', 'Sex', 'Sab'];
  private chatAppId: string | null = null;

  constructor(
    private fb: FormBuilder,
    private route: ActivatedRoute,
    private router: Router,
    private http: HttpClient,
    private toastr: ToastrService
  ) {
    this.realDeskForm = this.fb.group({
      id: [0],
      utilizarHorarioAtendimento: [false],
      fusoHorario: ['America/Sao_Paulo'],
      horarios: this.fb.array(this.dias.map((_, index) => this.fb.array([this.criarHorario(index)])))
    });
  }

  ngOnInit() {
    this.chatAppId = this.route.snapshot.paramMap.get('id');
    if (this.chatAppId) {
      this.loadData();
    }
  }

  private loadData() {
    this.http.get<any>(`${environment.apiUrl}/chatapp/edit/${this.chatAppId}`).subscribe(
      (response) => {
        this.realDeskForm.patchValue({
          id: response.id,
          utilizarHorarioAtendimento: response.utilizarHorarioAtendimento,
          fusoHorario: response.fusoHorario
        });

        this.carregarHorarios(response.horarios);
      }
    );
  }

  private criarHorario(dia: number): FormGroup {
    return this.fb.group({
      dia: [dia],
      inicio: [''],
      fim: ['']
    });
  }

  getHorariosDoDia(diaIndex: number): FormArray {
    return (this.realDeskForm.get('horarios') as FormArray).at(diaIndex) as FormArray;
  }

  addHorario(diaIndex: number) {
    this.getHorariosDoDia(diaIndex).push(this.criarHorario(diaIndex));
  }

  removeHorario(diaIndex: number, horarioIndex: number) {
    this.getHorariosDoDia(diaIndex).removeAt(horarioIndex);
  }

  private carregarHorarios(horariosApi: any[][]) {
    const horariosFormArray = this.realDeskForm.get('horarios') as FormArray;
  
    // Inicializa os dias da semana corretamente
    const diasSemana: FormArray[] = [];
    for (let i = 0; i < 7; i++) {
      diasSemana[i] = new FormArray<any>([]);
    }
  
    // Itera sobre os horários da API e distribui corretamente nos dias da semana
    horariosApi.forEach((horariosDia) => {
      horariosDia.forEach((horario) => {
        const diaIndex = horario.dia % 7;
        const horarioForm = this.fb.group({
          inicio: [this.formatarHorario(horario.inicio)],
          fim: [this.formatarHorario(horario.fim)]
        });
        diasSemana[diaIndex].push(horarioForm);
      });
    });
  
    // Atualiza o FormArray com os valores corrigidos
    horariosFormArray.clear();
    for (let i = 0; i < 7; i++) {
      horariosFormArray.push(diasSemana[i]);
    }
  }

  private formatarHorario(horario: string): string {
    const match = horario.match(/(\d+):(\d+)/);
    if (!match) return '';
    
    let horas = parseInt(match[1]);
    let minutos = match[2];
  
    if (horario.includes("PM") && horas !== 12) {
      horas += 12;
    } else if (horario.includes("AM") && horas === 12) {
      horas = 0;
    }
  
    return `${horas.toString().padStart(2, '0')}:${minutos}`;
  }

  save() {
    this.isLoading = true;
    this.http.post<any>(`${environment.apiUrl}/chatapp/edit/schedule`, this.realDeskForm.value).subscribe(
      (response) => {
        this.isLoading = false;
        this.toastr.success('Horários atualizados com sucesso');
        this.router.navigate(['/chatapp']);
      },
      (error) => {
        this.isLoading = false;
        this.toastr.error('Erro ao salvar horários');
      }
    );
  }

  cancel() {
    this.router.navigate(['/chatapp']);
  }
} 